var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrectWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16.2507C12.7279 16.2507 15.75 13.2287 15.75 9.50073C15.75 5.77281 12.7279 2.75073 9 2.75073C5.27208 2.75073 2.25 5.77281 2.25 9.50073C2.25 13.2287 5.27208 16.2507 9 16.2507ZM8.88373 12.2788L12.6337 7.77882L11.3662 6.72252L8.19451 10.5285L6.58331 8.9173L5.41658 10.084L7.66658 12.334L8.30538 12.9728L8.88373 12.2788Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectWhite);
export default __webpack_public_path__ + "static/media/correctWhite.2a4531a0df176634d6eb47f980afa6d6.svg";
export { ForwardRef as ReactComponent };